import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockCustomer = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CustomerRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/CustomerResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerCreateRequest.xml'} title={t('Пример запроса') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerCreateResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Создать')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerUpdateRequest.xml'} title={t('Пример запроса') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerUpdateResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Обновить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerDeleteRequest.xml'} title={t('Пример запроса') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerDeleteResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Удалить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerListRequest.xml'} title={t('Пример запроса') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerListResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Список')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerInfoRequest.xml'} title={t('Пример запроса') + ' ' + t('Получить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerInfoResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Получить')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/CustomerError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockCustomer;